import React from "react";

import {PRICING_FEATURE_PROPERTIES} from "../PricingFeatures/pricingFeatureProperties";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";
import PricingPopupContext, {usePricingPopupContext} from "./PricingPopupContext";
import {toggleArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";

const PricingPopupFeaturesProperties = () => {

  const {pricingPopupState, pricingPopupDispatch} = usePricingPopupContext(PricingPopupContext);
  const {featuresProperties} = pricingPopupState;

  return (
    <div className="pr-popup__content scrollbar3 mt-125 mb-125 pr-1">
      {Object.keys(PRICING_FEATURE_PROPERTIES).map((key) => {
        return (
          <div className="mb-1" key={key}>
            <PricingCheckbox id={key}
                             text={PRICING_FEATURE_PROPERTIES[key].translate || PRICING_FEATURE_PROPERTIES[key].backendName}
                             className="pr-checkbox--white color-textgray min-h-125 flex flex--center flex--start"
                             checked={featuresProperties.includes(key)}
                             onChange={() => pricingPopupDispatch({
                               featuresProperties: [...toggleArrayValue(featuresProperties, key)]
                             })}/>
          </div>
        )
      })}
    </div>
  )
};

export default PricingPopupFeaturesProperties
